module.exports = {
      id: "gn-reach-icon-usage",
      viewBox: "0 0 159 50",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#gn-reach-icon",
      toString: function () {
        return this.url;
      }
    }